import {Component, OnInit} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';

@Component({
  selector: 'tl-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
})
export class TermsAndConditionsComponent implements OnInit {
  constructor(
    private title: Title,
    private meta: Meta,
  ) {
  }
  ngOnInit(): void {
    this.title.setTitle('TheLysts, List it, Live it! - Terms and Conditions');
    this.meta.updateTag({name: 'description', content: 'Here, everything starts with the lists, but it does not end with them. They are a starting point for people to find products and services they want – and avoid traps. It is an opportunity to meet other like-minded people and form communities. Read more about our Terms and Conditions so it does not end ever.'});
    this.meta.updateTag({name: 'keywords', content: 'thelysts,lyst,list,task,organizer,privacy,policy,trip,suggestion,music,food,restaurants,sports,movies,films,tv series,podcasts,life style,cars,boats,app,recommendation,planner,beauty,fashion,celebrities,influencers,museums,golf,ongs'});
    this.meta.updateTag({property: 'og:title', content: 'TheLysts, List it, Live it! - Terms and Conditions'});
    this.meta.updateTag({property: 'og:image', content: 'https://thelysts.com/og-image/og-image-tos.jpg'});
    this.meta.updateTag({property: 'og:description', content: 'Here, everything starts with the lists, but it does not end with them. They are a starting point for people to find products and services they want – and avoid traps. It is an opportunity to meet other like-minded people and form communities. Read more about our Terms and Conditions so it does not end ever.'});
  }
}
